window.gwpCurrentCallback = null;

/* TODO: Uncomment if necessary */
var fetchConfig = (type = 'json') => {
  return {
    method: 'POST',
    headers: { 'Content-Type': 'application/json', Accept: `application/${type}` },
  };
}

async function checkGWP(cart, callback = null, callbackOnlyOnSuccess = false) {
  if (window.shop.giftWithPurchase.enableLog) {
    console.log('🎁 [GWP] 0.0 | IN checkGWP() FUNCTION');
    console.log('         0.1 | cart ', cart);
    console.log('         0.2 | callback ', callback);
    console.log('         0.3 | callbackOnlyOnSuccess ', callbackOnlyOnSuccess);
    console.log('--- --- --- ---');
  }

  var { giftVariantIds, giftProductIds, giftEnable, giftProductsAvailable, minCartPrice, eligibleProductIds, giftProductQuantity, onePerEligible } = window.shop.giftWithPurchase;

  giftProductIds = giftProductIds.map((id) => parseInt(id));
  giftProductsAvailable = giftProductsAvailable.map((availability) => availability == 'true');
  giftVariantIds = giftVariantIds.map((id) => parseInt(id));

  const asyncCart = cart ? cart : await getCart();
  // TODO: Add the sessionStorage when GWP Product is removed
  const isRemoved = sessionStorage.getItem('gwp') === 'removed';
  const totalGiftQuantity = asyncCart.items.reduce((sum, { variant_id, quantity }) => giftVariantIds.includes(variant_id) ? sum + quantity : sum, 0);
  const hasFreeGift = asyncCart.items.find((item) => giftVariantIds.includes(item.variant_id) && item.properties._isGWP) !== undefined;
  let eligibleProductCount = 0;
  const GWPPopup = document.querySelector('gwp-popup');


  if (window.shop.giftWithPurchase.enableLog) {
    console.log('🎁 [GWP] 1.0 | giftVariantIds ', giftVariantIds);
    console.log('         1.2 | giftProductIds ', giftProductIds);
    console.log('         1.3 | giftEnable ', giftEnable);
    console.log('         1.4 | giftProductsAvailable ', giftProductsAvailable);
    console.log('         1.5 | minCartPrice ', minCartPrice);
    console.log('         1.6 | eligibleProductIds ', eligibleProductIds);
    console.log('         1.7 | giftProductQuantity ', giftProductQuantity);
    console.log('         1.8 | onePerEligible ', onePerEligible);
    console.log('--- --- --- ---');
    console.log('🎁 [GWP] 2.0 | asyncCart ', asyncCart);
    console.log('         2.1 | isRemoved ', isRemoved);
    console.log('         2.2 | totalGiftQuantity ', totalGiftQuantity);
    console.log('         2.3 | hasFreeGift ', hasFreeGift);
    console.log('         2.4 | GWPPopup ', GWPPopup);
  }

  if (eligibleProductIds === 'all-products') {
    eligibleProductCount = asyncCart.items.reduce((sum, item) => !giftVariantIds.includes(item.variant_id) ? sum + item.quantity : sum, 0);
  } else {
    eligibleProductCount = asyncCart.items.reduce((sum, item) => eligibleProductIds.includes(item.product_id) ? sum + item.quantity : sum, 0);
  }

  if (window.shop.giftWithPurchase.enableLog) {
    console.log('🎁 [GWP] 3.0 | eligibleProductIds ', eligibleProductIds);
    console.log('         3.1 | eligibleProductCount ', eligibleProductCount);
    console.log('--- --- --- ---');
  }

  const requiredGiftQuantity = onePerEligible ? eligibleProductCount : (eligibleProductCount > 0 ? giftProductQuantity : 0);

  if (window.shop.giftWithPurchase.enableLog) {
    console.log('🎁 [GWP] 4.0 | requiredGiftQuantity ', requiredGiftQuantity);
    console.log('--- --- --- ---');
  }

  if (
    !giftEnable || isRemoved ||
    (giftVariantIds && giftProductsAvailable.every((availability) => !availability))
  ) {
    if (hasFreeGift) {
      const giftProductId = asyncCart.items.find((item) => giftVariantIds.includes(item.variant_id) && item.properties._isGWP).product_id;
      cartAjaxFetch(theme.routes.cart_change_url, giftProductId, Math.max(0, totalGiftQuantity - giftProductQuantity), callback)
    } else if (typeof callback === 'function' && !callbackOnlyOnSuccess) {
      callback();
    }
  } else if (
    giftEnable &&
    eligibleProductIds &&
    giftVariantIds &&
    giftProductsAvailable.some((availability) => availability)
  ) {
    var cartTotalPrice = asyncCart.total_price;
    var cartCurrency = asyncCart.currency;
    var cartTotalPrice__US_Dollar = Currency.convert(cartTotalPrice, cartCurrency, 'USD');

    if (
      totalGiftQuantity < requiredGiftQuantity &&
      cartTotalPrice__US_Dollar >= minCartPrice
    ) {
      if (
        eligibleProductIds === 'all-products' ||
        asyncCart.items
          .map((item) => item.product_id).some((product_id) => eligibleProductIds.includes(product_id))
      ) {
        if (giftProductIds.length > giftProductQuantity && GWPPopup) {
          if (window.shop.giftWithPurchase.enableLog) {
            console.log('🎁 [GWP] 5.0 | OPEN POPUP');
            console.log('--- --- --- ---');
          }
          GWPPopup.openGwpPopup(callback);
        } else {
          cartAjaxFetch(theme.routes.cart_add_url, giftVariantIds[0], giftProductQuantity, callback, { _isGWP: true });
        }
      } else if (typeof callback === 'function' && !callbackOnlyOnSuccess) {
        callback();
      }
    } else if (
      totalGiftQuantity > requiredGiftQuantity ||
      (totalGiftQuantity > 0 && cartTotalPrice__US_Dollar < minCartPrice) ||
      (asyncCart.items.length === 1 && asyncCart.items[0].quantity == 1 && hasFreeGift) ||
      (eligibleProductIds != 'all-products' && asyncCart.items
        .map((item) => item.product_id)
        .every((product_id) => giftProductIds.includes(product_id) || !eligibleProductIds.includes(product_id)))
    ) {
      const giftVariantId = asyncCart.items.find((item) => giftVariantIds.includes(item.variant_id) && item.properties._isGWP)?.variant_id;
      if (!giftVariantId) callback();
      cartAjaxFetch(theme.routes.cart_change_url, giftVariantId, Math.max(0, totalGiftQuantity - giftProductQuantity), callback);
    } else if (typeof callback === 'function' && !callbackOnlyOnSuccess) {
      callback();
    }
  } else if (typeof callback === 'function' && !callbackOnlyOnSuccess) {
    callback();
  }
};

async function getCart() {
  const result = await fetch('/cart.json');
  if (result.status === 200) {
      return result.json();
  }
  throw new Error(`Failed to get request, Shopify returned ${result.status} ${result.statusText}`);
}

function cartAjaxFetch(url, id, quantity, callback, properties = null) {
  var body = {
    id: id.toString(),
    quantity: quantity
  };

  if (properties) {
    body.properties = properties;
  }

  if (window.shop.giftWithPurchase.enableLog) {
    console.log('🎁 [GWP] 6.0 | AJAX url ', url);
    console.log('🎁 [GWP] 6.1 | AJAX body ', body);
    console.log('--- --- --- ---');
  }

  body = JSON.stringify(body);

  fetch(url, { ...fetchConfig(), ...{ body } })
  .then((response) => response.json())
  .then((response) => {
    if (response.status) return;
    callback(response);
  }).catch((e) => {
    console.error(e);
  });
}